/*
 * File: useGetPackageAgreement.ts
 * Author: Austin Robinson
 * Date Created: 8/20/2025
 * Copyright (c) DrivingDoc 2025
 */
import { createQuery } from 'react-query-kit';

import { publicApi } from 'api';

export interface GetPackageAgreementParams {
  packageId: string;
}

export interface GetPackageAgreementResult {
  html: string;
  hash: string;
}

async function getPackageAgreement({ packageId }: GetPackageAgreementParams) {
  // make api call
  const result = await publicApi.get<GetPackageAgreementResult>(`/public/packages/${packageId}/agreement`);

  // return the data object
  return result.data;
}

const useGetPackageAgreement = createQuery({
  queryKey: ['package_agreement'],
  fetcher: getPackageAgreement,
});

export { useGetPackageAgreement };
